import React from 'react';

const SectionHeader = ({ title, icon, isExpanded, onToggle }) => {
    return (
        <button
            className="w-full flex items-center justify-between px-3 py-3 text-left text-gray-700 hover:bg-gray-100 active:bg-gray-100 rounded-lg transition-colors touch-manipulation"
            onClick={onToggle}
        >
            <div className="flex items-center space-x-3">
                <svg className="w-5 h-5 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    {icon}
                </svg>
                <span className="font-medium">{title}</span>
            </div>
            <svg
                className={`w-4 h-4 transform transition-transform ${isExpanded ? 'rotate-180' : ''}`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
            >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
            </svg>
        </button>
    );
};

export default SectionHeader;
